import React from 'react';
import AppRoutes from './app/routing/AppRoutes';

// import './index.css';
// import './_template/assets/sass/style.scss'

import {createRoot} from 'react-dom/client'
import { AppProvider } from './app/routing/AuthContext';

import { Provider } from "react-redux";
import store from './app/redux/store';

const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <Provider store={store}>
      <AppProvider>
        <AppRoutes />
      </AppProvider>
    </Provider>
  )
}
